import {openSite} from './user';
import {
	initializeAssets,
	addAssets,
	removeAssets,
	switchToAsset,
	changeAsset,
	saveAsset,
	revertAsset,
	loadAssets,
	resetAssets,
	clearLoadResult,
	openLogFile,
	exportAssets,
	importAssets,
	validateAssets,
	validateAsset,
	setRaterType,
} from './assets';

const dispatchToPropsObject: ConfigEditor.DispatchToPropsObject = {
	setRaterType,
	openSite,
	initializeAssets,
	switchToAsset,
	addAssets,
	removeAssets,
	changeAsset,
	saveAsset,
	revertAsset,
	loadAssets,
	resetAssets,
	clearLoadResult,
	openLogFile,
	exportAssets,
	importAssets,
	validateAssets,
	validateAsset,
};

export default dispatchToPropsObject;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./ts/store/actions/config-editor/index.ts